export enum StoreStatus {
  Pending = 0,
  Active = 1,
  Suspended = 2,
  Rejected = 3,
}

export enum ProductStatus {
  Pending = 0,
  Approved = 1,
  Rejected = 2,
  OutOfStock = 3,
  NeedsRevision = 4,
}

export enum OrderStatus {
  Pending = 0,
  Confirmed = 1,
  Processing = 2,
  ReadyForPickup = 3,
  OutForDelivery = 4,
  Delivered = 5,
  Cancelled = 6,
  Returned = 7,
  Refunded = 8,
}

export enum DeliveryType {
  StoreDelivery = 0,
  PlatformDelivery = 1,
}

export enum PaymentMethod {
  COD = 0,
  Online = 1,
  Wallet = 2,
}

export enum PaymentStatus {
  Pending = 0,
  Completed = 1,
  Failed = 2,
  Refunded = 3,
  PartialRefund = 4,
}

export enum AddressType {
  Home = 0,
  Work = 1,
  Other = 2,
}

export enum ReferralType {
  User = 0,
  Store = 1,
}

export enum WalletOwnerType {
  User = 0,
  Store = 1,
  DeliveryPartner = 2,
  Admin = 3,
}

export enum TransactionType {
  Credit = 0,
  Debit = 1,
}

export enum TransactionCategory {
  OrderPayment = 0,
  OrderRefund = 1,
  ReferralCommission = 2,
  DeliveryCommission = 3,
  StoreSettlement = 4,
  Withdrawal = 5,
  AdminCommission = 6,
  WalletTopUp = 7,
  CashbackReward = 8,
  P2PTransferOut = 9,
  P2PTransferIn = 10,
  RewardPoolBonus = 11,
  SelfCashback = 12,
  LevelCashback = 13,
  RewardCashback = 14,
  IncomeReversal = 15,
  AdminAdjustment = 16,
}

export enum SettlementStatus {
  Pending = 0,
  Processing = 1,
  Completed = 2,
  Failed = 3,
}

export enum DeliveryPartnerStatus {
  Pending = 0,
  Active = 1,
  Suspended = 2,
  Rejected = 3,
}
